var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import IconGoogle from './icons/IconGoogle';
import IconLinkedIn from './icons/IconLinkedIn';
import IconCellPhone from './icons/IconCellPhone';
import Button from './common/Button';
import { useAuth, useConfigContext } from '@/hoc';
var SocialLogins = function (_a) {
    var socialLoginOptions = _a.socialLoginOptions, onSuccess = _a.onSuccess;
    var config = useConfigContext().config;
    var login = useAuth().login;
    var handleGoogleLogin = function () { return __awaiter(void 0, void 0, void 0, function () {
        var customerSecretKey, appIdentifier, metadata, authUrl, authRoute, authRoute, response, data, popup, checkPopup;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return __generator(this, function (_k) {
            switch (_k.label) {
                case 0:
                    customerSecretKey = config.customerSecretKey;
                    appIdentifier = config.appIdentifier;
                    metadata = encodeURIComponent(JSON.stringify([
                        {
                            meta_key: 'auth-provider',
                            meta_value: 'Google',
                        },
                    ]));
                    authUrl = '';
                    if (!(((_a = config === null || config === void 0 ? void 0 : config.googleAuth) === null || _a === void 0 ? void 0 : _a.flowType) === 'redirect')) return [3 /*break*/, 1];
                    authRoute = ((_c = (_b = config.googleAuth) === null || _b === void 0 ? void 0 : _b.endpoint) === null || _c === void 0 ? void 0 : _c.startsWith('http'))
                        ? (_d = config.googleAuth) === null || _d === void 0 ? void 0 : _d.endpoint
                        : "".concat(config.apiBaseUrl).concat((_e = config.googleAuth) === null || _e === void 0 ? void 0 : _e.endpoint);
                    authUrl = "".concat(authRoute, "?customer-secret-key=").concat(encodeURIComponent(customerSecretKey), "&app-identifier=").concat(encodeURIComponent(appIdentifier), "&metadata=").concat(metadata);
                    if (config.userTypeId) {
                        authUrl += "&userTypeId=".concat(encodeURIComponent(config.userTypeId));
                    }
                    if (config.userRoleId) {
                        authUrl += "&user_role_id=".concat(encodeURIComponent(config.userRoleId));
                    }
                    if (config.groupId) {
                        authUrl += "&group_id=".concat(encodeURIComponent(config.groupId));
                    }
                    if (config.productName) {
                        authUrl += "&productName=".concat(encodeURIComponent(config.productName));
                    }
                    return [3 /*break*/, 4];
                case 1:
                    authRoute = ((_g = (_f = config.googleAuth) === null || _f === void 0 ? void 0 : _f.endpoint) === null || _g === void 0 ? void 0 : _g.startsWith('http'))
                        ? (_h = config.googleAuth) === null || _h === void 0 ? void 0 : _h.endpoint
                        : "".concat(config.apiBaseUrl).concat((_j = config.googleAuth) === null || _j === void 0 ? void 0 : _j.endpoint);
                    return [4 /*yield*/, fetch("".concat(authRoute, "?customer-secret-key=").concat(encodeURIComponent(customerSecretKey), "&app-identifier=").concat(encodeURIComponent(appIdentifier), "&metadata=").concat(metadata), {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        })];
                case 2:
                    response = _k.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = _k.sent();
                    if (data === null || data === void 0 ? void 0 : data.redirect_url) {
                        authUrl = data.redirect_url;
                    }
                    else {
                        console.error('Failed to fetch Google auth URL');
                        return [2 /*return*/];
                    }
                    _k.label = 4;
                case 4:
                    popup = window.open(authUrl, 'GoogleAuth', 'width=500,height=600');
                    checkPopup = setInterval(function () {
                        if (!popup || popup.closed) {
                            clearInterval(checkPopup);
                        }
                    }, 1000);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleLinkedInLogin = function () { return __awaiter(void 0, void 0, void 0, function () {
        var customerSecretKey, appIdentifier, metadata, authUrl, authRoute, authRoute, response, data, popup, checkPopup;
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return __generator(this, function (_k) {
            switch (_k.label) {
                case 0:
                    customerSecretKey = config.customerSecretKey;
                    appIdentifier = config.appIdentifier;
                    metadata = encodeURIComponent(JSON.stringify([
                        {
                            meta_key: 'auth-provider',
                            meta_value: 'linkedin',
                        },
                    ]));
                    authUrl = '';
                    if (!(((_a = config === null || config === void 0 ? void 0 : config.linkedinAuth) === null || _a === void 0 ? void 0 : _a.flowType) === 'redirect')) return [3 /*break*/, 1];
                    authRoute = ((_c = (_b = config.linkedinAuth) === null || _b === void 0 ? void 0 : _b.endpoint) === null || _c === void 0 ? void 0 : _c.startsWith('http'))
                        ? (_d = config.linkedinAuth) === null || _d === void 0 ? void 0 : _d.endpoint
                        : "".concat(config.apiBaseUrl).concat((_e = config.linkedinAuth) === null || _e === void 0 ? void 0 : _e.endpoint);
                    authUrl = "".concat(authRoute, "?customer-secret-key=").concat(encodeURIComponent(customerSecretKey), "&app-identifier=").concat(encodeURIComponent(appIdentifier));
                    if (config.userTypeId) {
                        authUrl += "&userTypeId=".concat(encodeURIComponent(config.userTypeId));
                    }
                    if (config.userRoleId) {
                        authUrl += "&user_role_id=".concat(encodeURIComponent(config.userRoleId));
                    }
                    if (config.groupId) {
                        authUrl += "&group_id=".concat(encodeURIComponent(config.groupId));
                    }
                    if (config.productName) {
                        authUrl += "&productName=".concat(encodeURIComponent(config.productName));
                    }
                    return [3 /*break*/, 4];
                case 1:
                    authRoute = ((_g = (_f = config.linkedinAuth) === null || _f === void 0 ? void 0 : _f.endpoint) === null || _g === void 0 ? void 0 : _g.startsWith('http'))
                        ? (_h = config.linkedinAuth) === null || _h === void 0 ? void 0 : _h.endpoint
                        : "".concat(config.apiBaseUrl).concat((_j = config.linkedinAuth) === null || _j === void 0 ? void 0 : _j.endpoint);
                    return [4 /*yield*/, fetch("".concat(authRoute, "?customer-secret-key=").concat(encodeURIComponent(customerSecretKey), "&app-identifier=").concat(encodeURIComponent(appIdentifier)), {
                            method: 'GET',
                            headers: {
                                'Content-Type': 'application/json',
                            },
                        })];
                case 2:
                    response = _k.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    data = _k.sent();
                    if (data === null || data === void 0 ? void 0 : data.redirect_url) {
                        authUrl = data.redirect_url;
                    }
                    else {
                        console.error('Failed to fetch LinkedIn auth URL');
                        return [2 /*return*/];
                    }
                    _k.label = 4;
                case 4:
                    popup = window.open(authUrl, 'LinkedInAuth', 'width=500,height=600');
                    checkPopup = setInterval(function () {
                        if (!popup || popup.closed) {
                            clearInterval(checkPopup);
                        }
                    }, 1000);
                    return [2 /*return*/];
            }
        });
    }); };
    var availableSocialLogins = [
        {
            type: 'Google',
            icon: _jsx(IconGoogle, {}),
            background: '!vas-bg-orange-50',
            onClick: handleGoogleLogin,
        },
        {
            type: 'LinkedIn',
            icon: _jsx(IconLinkedIn, {}),
            background: '!vas-bg-blue-50',
            onClick: handleLinkedInLogin,
        },
        {
            type: 'Phone',
            icon: _jsx(IconCellPhone, {}),
            background: '!vas-bg-purple-50',
        },
    ];
    useEffect(function () {
        var receiveMessage = function (event) {
            var _a, _b, _c, _d, _e, _f;
            try {
                var data = event.data;
                if ((event.data.type === 'LINKEDIN_AUTH_SUCCESS' ||
                    event.data.type === 'GOOGLE_AUTH_SUCCESS') &&
                    (((_a = config === null || config === void 0 ? void 0 : config.googleAuth) === null || _a === void 0 ? void 0 : _a.flowType) === 'manual' || ((_b = config === null || config === void 0 ? void 0 : config.linkedinAuth) === null || _b === void 0 ? void 0 : _b.flowType) === 'manual')) {
                    var route = event.data.type === 'LINKEDIN_AUTH_SUCCESS'
                        ? (_c = config.linkedinAuth) === null || _c === void 0 ? void 0 : _c.sideEffectEndpoint
                        : (_d = config.googleAuth) === null || _d === void 0 ? void 0 : _d.sideEffectEndpoint;
                    var authRoute = (route === null || route === void 0 ? void 0 : route.startsWith('http')) ? route : "".concat(config.apiBaseUrl).concat(route);
                    fetch(authRoute, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            account_type: 'candidate',
                            auth_token: (data === null || data === void 0 ? void 0 : data.access_token) || (data === null || data === void 0 ? void 0 : data.accessToken) || '',
                            email: (_e = data === null || data === void 0 ? void 0 : data.user) === null || _e === void 0 ? void 0 : _e.email,
                            type: (data === null || data === void 0 ? void 0 : data.type) === 'LINKEDIN_AUTH_SUCCESS' ? 'linkedin-signup' : 'google-signup',
                        }),
                    }).then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
                        var res;
                        var _a, _b;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0: return [4 /*yield*/, response.json()];
                                case 1:
                                    res = _c.sent();
                                    if (res.success) {
                                        login({
                                            id: (res === null || res === void 0 ? void 0 : res.account_id) || ((_a = res === null || res === void 0 ? void 0 : res.user) === null || _a === void 0 ? void 0 : _a.id),
                                            access_token: (res === null || res === void 0 ? void 0 : res.access) || (res === null || res === void 0 ? void 0 : res.accessToken) || '',
                                            refresh_token: (res === null || res === void 0 ? void 0 : res.refresh) || (res === null || res === void 0 ? void 0 : res.refreshToken) || '',
                                            name: (_b = res === null || res === void 0 ? void 0 : res.user) === null || _b === void 0 ? void 0 : _b.name,
                                        });
                                        onSuccess();
                                    }
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                }
                else {
                    if (data.user) {
                        login({
                            id: (_f = data === null || data === void 0 ? void 0 : data.user) === null || _f === void 0 ? void 0 : _f.id,
                            access_token: (data === null || data === void 0 ? void 0 : data.access_token) || (data === null || data === void 0 ? void 0 : data.accessToken) || '',
                            refresh_token: (data === null || data === void 0 ? void 0 : data.refresh_token) || (data === null || data === void 0 ? void 0 : data.refreshToken) || '',
                            name: data === null || data === void 0 ? void 0 : data.user.name,
                        });
                        onSuccess();
                    }
                }
            }
            catch (error) {
                console.error('Invalid user data:', error);
            }
        };
        window.addEventListener('message', receiveMessage);
        return function () { return window.removeEventListener('message', receiveMessage); };
    }, []);
    return (_jsx("div", { className: 'vas-flex vas-flex-row vas-gap-3 vas-justify-center', children: availableSocialLogins
            .filter(function (loginOption) { return socialLoginOptions.includes(loginOption.type); })
            .map(function (loginOption) {
            return (_jsx(Button, { className: "vas-flex vas-items-center vas-gap-2 vas-py-2 vas-px-5 vas-rounded-lg vas-shadow-md ".concat(loginOption.background), icon: loginOption.icon, onClick: function () {
                    if (loginOption.onClick) {
                        loginOption.onClick();
                    }
                }, children: loginOption.type }, loginOption.type));
        }) }));
};
export default SocialLogins;
